import { ChevronsUpDown } from 'lucide-react';
import React, { Fragment, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { default as Logo } from 'src/assets/images/logos/miliboo-dp-min.svg?react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'src/components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from 'src/components/ui/sidebar';

export function ProjectSwitcher({
  projects,
}: {
  projects: {
    name: string;
    logo: ReactElement;
    link: string;
    plan: string;
  }[];
}) {
  const { isMobile } = useSidebar();
  const { t } = useTranslation('navigation');

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size='lg'
              className='data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground'
            >
              <div className='flex items-center'>
                <Logo className='size-8 text-sidebar' />
              </div>
              <div className='ml-2 grid flex-1 text-left text-sm leading-tight'>
                <span className='truncate font-semibold'>Demand Planning</span>
                <span className='truncate text-xs'>Miliboo</span>
              </div>
              <ChevronsUpDown className='ml-auto' />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className='min-w-52 rounded-lg'
            align='start'
            side={isMobile ? 'bottom' : 'right'}
            sideOffset={4}
          >
            <DropdownMenuLabel className='text-xs text-secondary-foreground'>
              {t('Projects')}
            </DropdownMenuLabel>
            {projects.map((project, index) => (
              <Fragment key={project.name}>
                <DropdownMenuItem className='p-2'>
                  <a
                    target='_blank'
                    href={project.link}
                    className='flex items-center gap-2'
                    rel='noreferrer'
                  >
                    <div className='flex-shrink-0'>{project.logo}</div>
                    <div className='mt-1 flex flex-col'>
                      <span className='font-medium'>{project.name}</span>
                      <span className='text-muted-foreground text-xs'>
                        {t(project.plan)}
                      </span>
                    </div>
                  </a>
                </DropdownMenuItem>
                {index !== projects.length - 1 && <DropdownMenuSeparator />}
              </Fragment>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
